import React, { useEffect, useState } from 'react';
import { Edit, ArrowBack } from "@mui/icons-material";
import styles from '../../assets/styles/LayoutShared.module.css';
import viewStyles from '../../assets/styles/LayoutSharedView.module.css';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../services/api';
import RegistroForm from './RegistroForm';


const ORIGEM_REGISTRO_LABEL: Record<string, string> = {
  whatsapp: 'WhatsApp',
  painel_web: 'Painel Web',
  app: 'App',
  agente_campo: 'Agente de campo',
};
// "demo/teste não confundidos com produção" (história "...modo de uso...",
// Task 2/N) — 'producao' nunca ganha selo (é o caso comum, não precisa
// chamar atenção); os outros dois sim, pra ficar óbvio que este registro
// não é dado real.
const DATA_SCOPE_LABEL: Record<string, string> = {
  demonstracao: 'Demonstração',
  teste: 'Teste',
};
const TIPO_LOCAL_LABEL: Record<string, string> = {
  bacia: 'Bacia', rio: 'Rio', represa: 'Represa',
  trecho_municipio: 'Trecho por município', area_pesca: 'Área de pesca', outro: 'Outro',
};

const RegistroView = () => {
  const navigate = useNavigate();
  const { uid } = useParams();
  const [data, setData] = useState<any>(null);
  const [formOpen, setFormOpen] = useState(false);

  const formatarDataBR = (dataRaw: string) => {
    if (!dataRaw) return '-';

    // Criamos o objeto Date, mas usamos os métodos UTC para extrair os valores reais do banco
    const d = new Date(dataRaw);
    const dia = String(d.getUTCDate()).padStart(2, '0');
    const mes = String(d.getUTCMonth() + 1).padStart(2, '0');
    const ano = d.getUTCFullYear();

    return `${dia}/${mes}/${ano}`;
  };

  const formatarDataHoraBR = (dataRaw?: string) => {
    if (!dataRaw) return '-';
    const d = new Date(dataRaw);
    const dia = String(d.getDate()).padStart(2, '0');
    const mes = String(d.getMonth() + 1).padStart(2, '0');
    const ano = d.getFullYear();
    const hora = String(d.getHours()).padStart(2, '0');
    const min = String(d.getMinutes()).padStart(2, '0');
    return `${dia}/${mes}/${ano} às ${hora}:${min}`;
  };

  const fetchRegistro = () => {
    if (!uid) return;
    api.get(`/pesca/registros/view/${uid}`).then(res => setData(res.data.data));
  };

  useEffect(() => {
    fetchRegistro();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uid]);

  const handleSalvo = () => {
    setFormOpen(false);
    fetchRegistro();
  };
  
  const calcularPesoConvertido = (peso: string | number, apresentacao: string) => {
    if (peso === null || peso === undefined) return 0;
    const p = parseFloat(peso.toString()) || 0;
    if (apresentacao === 'eviscerado') return p * 1.2; // +20%
    // Banco/formulário usam "filé" (com acento) — "file" nunca batia.
    if (apresentacao === 'filé') return p * 3;        // Multiplica por 3
    return p;
  };

  if (!data) return <div className={viewStyles.container}>Carregando...</div>;

  const totalInformado = data.itens?.reduce((acc: number, i: any) =>
    acc + (parseFloat(i.peso_kg) || 0), 0) || 0;

  const totalConvertido = data.itens?.reduce((acc: number, i: any) =>
    acc + calcularPesoConvertido(i.peso_kg, i.apresentacao), 0) || 0;

  return (
    <div className={viewStyles.container}>
      <div className={viewStyles.headerTitle}>
        <h1 className={viewStyles.greenTitle}>Detalhes da Pescaria</h1>
        <div className={viewStyles.actionsHeader}>
          <button className={viewStyles.blueBtn} onClick={() => setFormOpen(true)}><Edit fontSize="small" /></button>
          <button className={viewStyles.blueBtn} onClick={() => navigate(-1)}><ArrowBack fontSize="small" /></button>
        </div>
      </div>

      <div className={viewStyles.sectionCard}>
        <div className={viewStyles.sectionHeader}>DADOS GERAIS</div>
        <div className={viewStyles.sectionBody}>
          <div className={viewStyles.gridInfo}>
            <div><label>Pescador</label><p>{data.pescador?.nome}</p></div>
            <div><label>Data</label><p>{formatarDataBR(data.data_inicio)}</p></div>

            {/* ADICIONADOS: Local e Esforço */}
            <div><label>Local (Ambiente)</label>
              <p>
                {data.uid_pesca_local_tbl_pesca_local
                  ? <>{data.uid_pesca_local_tbl_pesca_local.nome} <span style={{ color: '#888', fontSize: '0.85em' }}>({TIPO_LOCAL_LABEL[data.uid_pesca_local_tbl_pesca_local.tipo] || data.uid_pesca_local_tbl_pesca_local.tipo})</span></>
                  : (data.descricao_local || '-')}
                {' '}({data.ambiente || 'Não inf.'})
              </p>
              {!data.uid_pesca_local_tbl_pesca_local && data.descricao_local && (
                <p style={{ fontSize: '0.78rem', color: '#e08a00', margin: '2px 0 0' }}>
                  Local ainda não reconhecido — pendente de classificação (ver tela Pendências de Local)
                </p>
              )}
              {data.uid_pesca_local_tbl_pesca_local && (
                <p style={{ fontSize: '0.78rem', color: '#999', margin: '2px 0 0' }}>
                  Precisão: {data.precisao_local === 'exato' ? 'exata (GPS)' : data.precisao_local === 'aproximado' ? 'aproximada (texto)' : 'não informada'}
                  {data.descricao_local ? ` — texto original: "${data.descricao_local}"` : ''}
                </p>
              )}
            </div>
            <div><label>Nº Pescadores / Barcos</label>
              <p>{data.num_pescadores || 1} pesc. / {data.num_embarcacoes || 0} barcos</p>
            </div>

            <div><label>Peso Informado (Total)</label><p>{totalInformado.toFixed(2)} kg</p></div>
            <div><label>Peso Convertido (Peixe Inteiro)</label>
              <p style={{ color: 'var(--green-700)', fontWeight: 'bold' }}>{totalConvertido.toFixed(2)} kg</p>
            </div>
          </div>

          {/* ADICIONADO: Observação, se existir */}
          {data.observacao && (
            <div style={{ marginTop: '15px', padding: '10px', background: '#f9f9f9', borderRadius: '4px' }}>
              <label style={{ fontSize: '0.8rem', color: '#888' }}>Observações:</label>
              <p style={{ margin: '5px 0 0 0' }}>{data.observacao}</p>
            </div>
          )}
        </div>
      </div>

      {/* SEÇÃO DA TABELA FORMATADA */}
      <div className={viewStyles.sectionCard}>
        <div className={viewStyles.sectionHeader}>ESPÉCIES CAPTURADAS</div>
        <div className={viewStyles.tableWrapper} style={{ marginTop: '0' }}>
          <table className={styles.table}>
            <thead className={styles.tableSubHeader}>
              <tr>
                <th style={{ width: '24%' }}>Espécie</th>
                <th style={{ width: '16%' }}>Apresentação</th>
                <th style={{ width: '18%', textAlign: 'right' }}>Peso Informado</th>
                <th style={{ width: '18%', textAlign: 'right' }}>Quantidade</th>
                {/* Largura maior e sem quebra para o Peso Convertido */}
                <th style={{ width: '24%', textAlign: 'right', whiteSpace: 'nowrap' }}>
                  Peso Convertido (Inteiro)
                </th>
              </tr>
            </thead>
            <tbody>
              {data.itens?.map((item: any) => {
                // Captura pode ter sido registrada por peso OU por quantidade
                // (nunca os dois) — peso_kg nulo aqui não é "0 kg", é "não
                // se aplica", senão a linha parece uma captura vazia/zerada.
                const temPeso = item.peso_kg !== null && item.peso_kg !== undefined;
                const convertido = temPeso ? calcularPesoConvertido(item.peso_kg, item.apresentacao) : null;
                return (
                  <tr key={item.uid_pesca_captura_item}>
                    <td>{item.especie?.nome_popular}</td>
                    <td style={{ textTransform: 'capitalize' }}>{item.apresentacao}</td>
                    <td style={{ textAlign: 'right' }}>
                      {temPeso ? `${parseFloat(item.peso_kg).toFixed(2)} kg` : '-'}
                    </td>
                    <td style={{ textAlign: 'right' }}>
                      {item.quantidade !== null && item.quantidade !== undefined ? `${item.quantidade} un` : '-'}
                    </td>
                    <td style={{ textAlign: 'right', fontWeight: 'bold', whiteSpace: 'nowrap' }}>
                      {convertido !== null ? `${convertido.toFixed(2)} kg` : '-'}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      {/* SEÇÃO ARTES UTILIZADAS - PADRONIZADA */}
      <div className={viewStyles.sectionCard}>
        <div className={viewStyles.sectionHeader}>
          <span>ARTES UTILIZADAS</span>
        </div>
        <div className={viewStyles.tableWrapper} style={{ marginTop: '0' }}>
          <table className={styles.table}>
            <thead className={styles.tableSubHeader}>
              <tr>
                <th style={{ textAlign: 'left' }}>Arte de Pesca</th>
              </tr>
            </thead>
            <tbody>
              {data.apetrechos && data.apetrechos.length > 0 ? (
                data.apetrechos.map((item: any) => (
                  <tr key={item.uid_pesca_registro_apetrecho}>
                    <td style={{ textAlign: 'left' }}>{item.apetrecho?.nome || 'Não informado'}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={2} style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
                    Nenhuma arte de pesca registrada para esta pescaria.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* SEÇÃO HISTÓRICO — autoria do registro + status/autoria da validação.
          Status de validação nunca fica salvo — é sempre calculado
          cruzando projeto.exige_validacao com data_validacao. */}
      <div className={viewStyles.sectionCard}>
        <div className={viewStyles.sectionHeader}>HISTÓRICO</div>
        <div className={viewStyles.sectionBody}>
          <div className={viewStyles.gridInfo}>
            <div>
              <label>Registrado por</label>
              <p>
                {/* Quem operou: o operador (painel ou agente de campo) quando
                    diferente do pescador; senão o próprio pescador. */}
                {data.uid_usuario_registro_tbl_usuario?.nome ||
                  (data.origem_registro === 'painel_web' || data.origem_registro === 'agente_campo'
                    ? (data.origem_registro === 'agente_campo' ? 'Agente de campo' : 'Operador do painel')
                    : (data.pescador?.nome || 'Pescador'))}
                {' '}
                <span style={{ color: '#888', fontSize: '0.85em' }}>
                  ({ORIGEM_REGISTRO_LABEL[data.origem_registro] || 'WhatsApp'})
                </span>
                {DATA_SCOPE_LABEL[data.data_scope] && (
                  <span
                    style={{
                      marginLeft: 8, fontSize: '0.68rem', fontWeight: 700, color: '#8a3b00',
                      background: '#ffe4cc', padding: '2px 8px', borderRadius: 10, textTransform: 'uppercase',
                    }}
                  >
                    {DATA_SCOPE_LABEL[data.data_scope]}
                  </span>
                )}
              </p>
            </div>
            <div>
              <label>Data do registro</label>
              <p>{formatarDataHoraBR(data.syn_cadmom)}</p>
            </div>
            <div>
              <label>Validação</label>
              {!data.projeto?.exige_validacao ? (
                <p style={{ color: '#999' }}>Este projeto não exige validação.</p>
              ) : data.data_validacao ? (
                <p style={{ color: 'var(--green-700)' }}>
                  Validado por {data.uid_usuario_validacao_tbl_usuario?.nome || '-'} em {formatarDataHoraBR(data.data_validacao)}
                </p>
              ) : (
                <p style={{ color: '#e08a00' }}>Pendente de validação.</p>
              )}
            </div>
          </div>
        </div>
      </div>

      {formOpen && uid && (
        <RegistroForm
          registroUid={uid}
          onClose={() => setFormOpen(false)}
          onSaved={handleSalvo}
        />
      )}
    </div>
  );
};

export default RegistroView;
